import React, { useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import HeroSection from "./sections/HeroSection";
import KnowledgeBankSection from "./sections/KnowledgeBankSection";
import ReportComparisonSection from "./sections/ReportComparisonSection";
import BenefitsSection from "./sections/BenefitsSection";
import OnboardingFlowSection from "./sections/OnboardingFlowSection";
import SupportSection from "./sections/SupportSection";
import "./introPage.css";

const IntroPage = () => {
  const theme = useTheme();

  // ── Clarity Event Tracking ──────────────────────────────────────────────
  useEffect(() => {
    const handleClick = (e) => {
      if (typeof window.clarity !== 'function') return;

      const el = e.target.closest('[class], button, a, div, span, li, p');
      if (!el) return;
      const text = el.innerText?.trim().toLowerCase() || '';

      // 1. Talk to Shweta (Hero CTA)
      if (text.includes('talk to shweta')) {
        window.clarity('set', 'cta_clicked', 'talk_to_shweta');
        window.clarity('event', 'home_talk_to_shweta_clicked');
      }

      // 2. Report Type Tabs
      if (text === 'personal') {
        window.clarity('set', 'report_tab_viewed', 'personal');
        window.clarity('event', 'home_report_tab_personal_clicked');
      }
      if (text === 'total') {
        window.clarity('set', 'report_tab_viewed', 'total');
        window.clarity('event', 'home_report_tab_total_clicked');
      }
      if (text === 'compact') {
        window.clarity('set', 'report_tab_viewed', 'compact');
        window.clarity('event', 'home_report_tab_compact_clicked');
      }

      // 3. Connect on LinkedIn (Joyneel Acharya & Shweta Gandhi)
      if (text.includes('connect on linkedin')) {
        const card = el.closest('[class*="card"], [class*="team"], section, div');
        const name = card?.querySelector('h2,h3,h4,[class*="name"]')
                        ?.innerText?.trim() || 'unknown';
        window.clarity('set', 'linkedin_connect_clicked', name);
        window.clarity('event', 'home_linkedin_connect_clicked');
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  // ────────────────────────────────────────────────────────────────────────

  // Use SVG from public folder
  const backgroundSvgPath = "/images/introPage/assets/illustrations/job297-ploy-07c-blue-01.svg";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      {/* Content wrapper to ensure all sections appear above background */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
        }}
      >
        {/* Hero Section - Full width with gradient */}
        <HeroSection />
        
        {/* Knowledge Bank - Light blue gradient background */}
        <ReportComparisonSection />
        
        <KnowledgeBankSection />
        
        
        {/* Benefits - Gradient background with split colors */}
        <BenefitsSection />
        
        {/* Onboarding Flow - Light gradient background */}
        <OnboardingFlowSection />
        
        {/* Support - White to light blue gradient */}
        <SupportSection />
      </Box>
    </Box>
  );
};

export default IntroPage;

